import Image from 'next/image'
import imgBachelor from './images/diploma-bachelor.jpg'
import imgDiplomaProfessionalRetraining from './images/diploma-professional-retraining.jpg'
import imgDiploma from './images/diploma-en.jpg'
import imgSupplement from './images/supplement.jpg'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import { Button } from '~shared/components/button-v2'
import { useState } from 'react'
import { cn } from '~shared/utils/cn'
import { DocumentCard } from '~pages/home-page/components/graduation-docs-section'

// ─── Component ────────────────────────────────────────────────────────────────

export const DiplomasSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const diplomas = [...(program?.diplomas ?? [])].sort(
    (a, b) => Number(a?.rank) - Number(b?.rank)
  )

  const [tab, setTab] = useState<string>(diplomas?.[0]?.name || '')

  if (!diplomas) return null

  const tabs = [
    ...diplomas.map(
      (diploma: { name: any; imageDefault: any; description: any }) => ({
        name: diploma?.name ?? '',
        image: diploma?.imageDefault ?? '',
        content: diploma?.description ?? ''
      })
    )
  ]
  const currentTab = tabs.find(tabConfig => tabConfig?.name === tab)
  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium  mb-[32px] 2lg:mb-[48px]'>
          Документы по окончании обучения
        </h2>
        {tabs?.length > 1 ? (
          <div
            className={cn(
              'flex  lg:gap-[16px] whitespace-nowrap overflow-x-auto',
              'mt-[30px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]'
            )}>
            {tabs?.map(diploma => (
              <div
                key={diploma.name}
                className='flex-shrink-0 pr-[8px] lg:pr-0 overflow-hidden rounded-[16px] md:rounded-[24px]'>
                <Button
                  size='none'
                  variant='none'
                  wrap
                  className={cn(
                    'min-h-[50px] md:min-h-[67px] px-[24px] max-w-full w-full !rounded-[16px] md:!rounded-[24px]',
                    tab === diploma?.name
                      ? 'bg-accent text-primary'
                      : 'bg-secondary text-tertiary'
                  )}
                  onClick={() => setTab(diploma.name!)}>
                  {diploma.name}
                </Button>
              </div>
            ))}
          </div>
        ) : null}
        <DocumentCard
          key={currentTab?.name ?? ''}
          title={currentTab?.name ?? ''}
          image={currentTab?.image ?? ''}>
          {currentTab?.content ?? ''}
        </DocumentCard>
      </div>
    </section>
  )
}
